import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <Layout>
      <div className="dashboard">
      <main className="dashboard-main">
        <div className="dashboard-cards">
          <Link to="/tenants" className="dashboard-card">
            <h2>Tenants</h2>
            <p>Manage tenants, solutions, and units</p>
          </Link>
          <Link to="/solutions" className="dashboard-card">
            <h2>Solutions</h2>
            <p>Create and manage solution templates</p>
          </Link>
        </div>
      </main>
    </div>
    </Layout>
  );
};

export default Dashboard;

